/* eslint-disable ember/no-classic-classes */
import Controller from "@ember/controller";

export default Controller.extend({
  queryParams: ["reset"],
});
